import "rxjs/add/operator/toPromise";
import {Injectable} from "@angular/core";
import {Headers, Http} from "@angular/http";
import {TranslateService} from "@ngx-translate/core";
import {LoadingService} from "./loading";
import {StateService} from "./state";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class ApiService {
    constructor(public http: HttpClient,
                public state: StateService,
                public loadingService: LoadingService,
                public translateService: TranslateService) {
    }

    call(path: string, parameter?: any, message?: string, fullscreen?: boolean, force?: boolean, hide?: boolean): Promise<any> {
        return this.state.getState('apiUrl').then(api => {
            return this.state.getLanguage().then(lang => {
                return this.state.getSessionId().then(sessionId => {
                    if (!hide) {
                        this.translateService.get(message || "GLOBAL.LC_LOADING").subscribe((value) => {
                            this.loadingService.show(value, fullscreen, force);
                        });
                    }

                    //api = api.replace(/^http(s)?:/, window.location.protocol);

                    let url = api + ((path.charAt(0) == "/") ? "" : "/") + path,
                        header: HttpHeaders = new HttpHeaders();

                    if (sessionId) {
                        header = header.set('Fw-Session-ID', sessionId);
                    }

                    if (lang) {
                        header = header.set('Fw-Language', lang);
                    }
                    header = header.set('Fw-Ajax', 'true');
                    let request: Promise<any> = this.http.post(url, JSON.stringify(parameter), {headers: header}).toPromise();
                    request
                        .then((response) => {
                            this.loadingService.hide(force);
                        })
                        .catch((error) => {
                            this.loadingService.hide(force);

                            if (error && error.statusText) {
                                let response = {
                                    title: '',
                                    message: ''
                                };

                                try {
                                    response = JSON.parse(error.statusText);
                                } catch (exception) {
                                    response = {
                                        title: 'Fehler: ' + error.status,
                                        message: error.statusText
                                    };

                                    console.trace('FEHLER' + error.status);
                                }
                            }
                            return Promise.resolve();
                        });
                    return request;
                })
            })
        })

    }
}



// WEBPACK FOOTER //
// ./src/app/service/api.ts